import { ritmDate } from '@/utils'

export const formatValue = function(item, val) {
  if (val === null || typeof val !== 'string') return val

  console.log('val', val)
  const date = val ? ritmDate.toFormat(val) : null

  const type = item.datatype || item.type
  console.log('date', date, type)
  switch (type) {
    case 'datetime':
    case 'time':
    case 'timestamptz':
      return date?.toLocaleString('ru-RU') || date
    case 'date':
      return date ? ritmDate.toFormat(date, 'DD.MM.YYYY') : ''
    case 'number':
    case 'integer':
    case 'numeric':
    case 'float':
    case 'decimal':
      return val?.toLocaleString('ru-RU') || val
    case 'jsonb':
      if (val && Array.isArray(val)) {
        if (typeof val?.[0] === 'object') {
          return val?.map(v => v?.name || 'нет значения')?.join(', ')
        } else {
          return val && Array.isArray(val) ? val?.join(', ') : ''
        }
      }
      return ''
    default:
      return val
  }
}

export const arrayMoveByIndex = (arr, from, to) => {
  const elem = arr[from]

  arr.splice(from, 1)
  arr.splice(to, 0, elem)
}
